import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Calendar, ArrowRight } from 'lucide-react';

const OmOss = () => {
  const { t } = useLanguage();

  const renderParagraphs = (key) =>
    t(key).split('\n\n').map((para, i) => (
      <p key={i} className="om-oss-text">{para}</p>
    ));

  return (
    <div className="om-oss-page">
      <section className="om-oss-section first-section">
        <div className="section-container">
          <h1 className="om-oss-heading">{t('omOssTitle1')}</h1>
          <div className="om-oss-text-content">
            {renderParagraphs('omOssText1')}
          </div>
        </div>
      </section>

      <section className="om-oss-section">
        <div className="section-container">
          <h2 className="om-oss-heading">{t('omOssTitle2')}</h2>
          <div className="om-oss-text-content">
            {renderParagraphs('omOssText2')}
          </div>
        </div>
      </section>

      <section className="om-oss-section">
        <div className="section-container">
          <h2 className="om-oss-heading">{t('omOssTitle3')}</h2>
          <div className="om-oss-text-content">
            {renderParagraphs('omOssText3')}
          </div>
        </div>
      </section>

      <section className="om-oss-cta-section">
        <div className="section-container">
          <div className="om-oss-cta-content">
            <div className="cta-icon-badge">
              <Calendar size={32} />
            </div>
            <h2 className="om-oss-cta-title">{t('omOssCta')}</h2>
            <p className="om-oss-cta-subtitle">{t('omOssCtaSubtext')}</p>
            <a
              href="https://calendly.com/partsnap-info/15min"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button om-oss-cta-button"
            >
              <span>{t('omOssCtaButton').toUpperCase()}</span>
              <ArrowRight className="button-icon" size={20} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OmOss;
